export const EquationPlace = () =>{
    return(
        <div className="container">
            <p>数式エディタのカードの存在場所を示します</p>
            <img src={`${process.env.PUBLIC_URL}/equation_place.png`}></img>
            <p>図の例では自分の手札を表しています。フィールドやデッキ墓地も指定することが可能です</p>
            </div>
    )
}
